module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marco Vassi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marco Vassi was, without a doubt, the foremost erotic writer of our generation. Praised by Norman Mailer, Kate Millett, Saul Bellow, and Gore Vidal, he was not only the ultimate sexual explorer, but a literary craftsman whose own life experiences became the stuff of his fiction—expanded, of course, by a grand imagination and a full sense of the absurd."), _c('BR'), _c('BR'), _vm._v(" Tragically, Vassi died from pneumonia after he had contracted AIDS.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EhdST8/tc-custom/9781497634763.jpg?1704761351276",
      "alt": "This image is the cover for the book Slave Lover, The Vassi Collection"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Slave Lover, The Vassi Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("”Constance was a quick‑minded woman, twenty‑seven years old, a freelance writer who had begun to make a reputation among some of the more solid publications. She had a wide‑ranging intelligence, and her pieces covered everything from Middle East politics to new tendencies in American religious thought. Her latest interest had been in something that most people consider a dead issue: the white slave trade.”"), _c('br'), _c('br'), _vm._v(" But in one of Marco Vassi’s most daring novels, Constance is about to learn that it is very much alive, vibrant even, and her experiences will turn professional conflict into personal turmoil. “Have a pleasant experience.”")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0